// API Configuration for Harvesters Performance Module
// Base URL for all API endpoints
export const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'https://dev-sakti.gbs.id/api/insight'}/harvester`;

// Performance API endpoints
export const PERFORMANCE_ENDPOINTS = {
    // Main dashboard endpoint
    DASHBOARD: `${API_BASE_URL}/performance/dashboard`,

    // Harvester detail endpoint
    DETAIL: (pemanenId: number) => `${API_BASE_URL}/performance/detail/${pemanenId}`,

    // Benchmark data endpoint  
    BENCHMARK: `${API_BASE_URL}/performance/benchmark`,

    // Filter options endpoint
    FILTERS: `${API_BASE_URL}/performance/filters`,
} as const;

// User management endpoints
export const USER_ENDPOINTS = {
    // Get all pemanen data
    PEMANEN: `${API_BASE_URL}/user/pemanen`,

    // Category permissions (if needed for future integration)
    CATEGORY_PERMISSIONS: `${API_BASE_URL}/user/category-permissions`,
} as const;

// Helper function to build URL with query parameters
export const buildUrlWithParams = (baseUrl: string, params: Record<string, string | number | undefined>) => {
    const urlParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            urlParams.set(key, value.toString());
        }
    });

    const queryString = urlParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

// Common API parameter builders
export const buildDashboardParams = (filters: {
    startDate?: string;
    endDate?: string;
    estateId?: number | '';
    divisiId?: number | '';
    limit?: number;
}) => ({
    start_date: filters.startDate,
    end_date: filters.endDate,
    estate_id: filters.estateId,
    divisi_id: filters.divisiId,
    limit: filters.limit,
});

export const buildDetailParams = (dateRange: {
    startDate?: string;
    endDate?: string;
}) => ({
    start_date: dateRange.startDate,
    end_date: dateRange.endDate,
});

export const buildBenchmarkParams = (filters: {
    startDate?: string;
    endDate?: string;
    estateId?: number | '';
    divisiId?: number | '';
}) => ({
    start_date: filters.startDate,
    end_date: filters.endDate,
    estate_id: filters.estateId,
    divisi_id: filters.divisiId,
});

// API Error messages in Indonesian
export const API_ERROR_MESSAGES = {
    NETWORK_ERROR: 'Gagal terhubung ke server. Periksa koneksi internet Anda.',
    SERVER_ERROR: 'Terjadi kesalahan pada server. Silakan coba lagi nanti.',
    UNAUTHORIZED: 'Sesi Anda telah berakhir. Silakan login kembali.',
    FORBIDDEN: 'Anda tidak memiliki akses untuk melihat data ini.',
    NOT_FOUND: 'Data yang diminta tidak ditemukan.',
    VALIDATION_ERROR: 'Data yang dikirim tidak valid. Periksa kembali input Anda.',
    TIMEOUT: 'Permintaan memakan waktu terlalu lama. Silakan coba lagi.',
    UNKNOWN: 'Terjadi kesalahan yang tidak diketahui. Silakan hubungi administrator.',
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
    DATA_LOADED: 'Data berhasil dimuat',
    DATA_EXPORTED: 'Data berhasil diekspor',
    DATA_REFRESHED: 'Data berhasil diperbarui',
} as const;
